/* istanbul ignore file */
import React, { lazy } from 'react'
import { Redirect } from '@fs/zion-router'

import NewSurnamePage from './pages/NewSurnamePage'
import SiteRoute from '../../components/SiteRoute'

const ExperiencesPage = lazy(() => import('./pages/ExperiencesPage'))
const FamilyInterviewQuestionsPage = lazy(() => import('./pages/FamilyInterviewQuestionsPage'))
const FamilyTreePage = lazy(() => import('./pages/FamilyTreePage'))
const PhilippinesNLIHP = lazy(() => import('./pages/PhilippinesNLIHP'))
const ProvinceLandingPage = lazy(() => import('./pages/ProvincePage/ProvinceLandingPage'))
const BaybayinPage = lazy(() => import('./pages/BaybayinPage'))
const SurnameLandingPage = lazy(() => import('./pages/SurnameLandingPage'))
const ProvincePageNew = lazy(() => import('./pages/ProvincePageNew'))
const TreeTemplatesPage = lazy(() => import('./pages/TreeTemplatesPage'))

const FAMILY_TREE_FLAG = 'homelands_asiaPacific_philippinesFamilyTree'

export default [
  <SiteRoute key="nlihp" exact path="/" component={PhilippinesNLIHP} />,
  <SiteRoute key="province-landing" exact path="/province" component={ProvinceLandingPage} />,
  <SiteRoute key="province" path="/province/:province" component={ProvincePageNew} />,
  <SiteRoute key="experiences" path="/experiences" component={ExperiencesPage} />,
  <SiteRoute key="surname-landing" exact path="/surname" component={SurnameLandingPage} />,
  <SiteRoute key="surname" path="/surname/:surname" component={NewSurnamePage} />,
  <SiteRoute
    key="baybayin-translator-name-landing"
    exact
    path="/baybayin-translator-name"
    render={() => <Redirect to="/baybayin" />}
  />,
  <SiteRoute
    key="baybayin-translator-name"
    path="/baybayin-translator-name/:surname"
    render={() => <Redirect to="/baybayin" />}
  />,
  <SiteRoute key="baybayin" path="/baybayin" component={BaybayinPage} />,
  <SiteRoute key="family-tree" exact path="/family-tree" component={FamilyTreePage} featureFlag={FAMILY_TREE_FLAG} />,
  <SiteRoute
    key="family-tree-interview-questions"
    exact
    path="/family-tree/family-interview-questions"
    component={FamilyInterviewQuestionsPage}
    featureFlag={FAMILY_TREE_FLAG}
  />,
  <SiteRoute
    key="family-tree-templates"
    exact
    path="/family-tree/tree-templates"
    component={TreeTemplatesPage}
    featureFlag={FAMILY_TREE_FLAG}
  />,
]
